module.exports = __webpack_public_path__ + "static/media/delivery-list-icon.5120ad6e.svg";